import React, { useEffect, useRef, useState } from "react"
import styled from "styled-components"
import SilverBar from "../common/assets/silver-bar.png"
import GoldBar from "../common/assets/gold-bar.png"
import LogoImg from "../common/assets/logo-pic.png"
import Loading from "../common/assets/icons8-load.gif"
import BgVideo from "../common/assets/background-video.mp4"

const HomeWrapper = styled.div`
    height: 90vh;
    padding-top: 10vh;
    #background-image{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 80vh;
        @media screen and (max-width: 600px){
            height: 70vh;
        }
        @media screen and (max-width: 400px){
            height: 65vh;
        }
        
        img{
            height: 100vh;
            width: 100%;
            object-fit: cover;
        }
        video{
            height: 100vh;
            width: 100%;
            object-fit: cover;
        }
        video::-webkit-media-controls-fullscreen-button {
            display: none !important;
        }
        .bg-wrapper {
            position: absolute;
            inset: 0;
            overflow: hidden;
            z-index: 1;
        }


        #bg-color{
            position: absolute;
            background: #fff;
            rotate: 10deg;
            z-index: 1;
            height: 130vh;
            width: 50vw;
            left: -10%;
            top: -30%;
            opacity: 70%;
            img{
                rotate: -10deg;
                object-fit: contain;
                position: absolute;
                top: 20%;
                left: 40%;
                opacity: 60%;
                width: 85%;
            }
            @media screen and (max-width: 900px){
                width: 70vw; 
                img{
                    left: 30%;
                }
            }
            @media screen and (max-width: 600px){
                width: 100vw;
                rotate: 23deg;
                left: -35%;
                img{
                    rotate: -23deg;
                    left: 40%;
                    top: 10%;
                    width: 90vw;
                }
            }
            @media screen and (max-width: 450px){
                width: 105vw;
                left: -25%;
                img{
                    left: 15%;
                    top: 5%;
                }
            }
        }
    }

    #silver-gold-price{
        #price-wrapper{
            width: 100%;
            height: 10vh;
            min-height: 80px;
            background-color: #44647c;
            position: absolute;
            z-index:10;
            display: flex;
            justify-content: center;
            gap: 6vw;
            
            @media screen and (max-width: 600px){
                flex-direction: column;
                height: 20vh;
                gap: 0vh;
                align-items: center;
                img{
                    max-height: 10vh;
                }
            }
            @media screen and (max-width: 400px){
                height: 25vh;
            }
            .price-info{
                display: flex;
                align-items: center;
                
                img{
                    height: 50%;
                }
                .price{
                    margin-left: 18px;
                    color: #fff;
                    font-size: 1.2rem;
                    font-weight: 600;
                }
            }
        }
        p{
            color: #fff;
            font-size: 0.8rem;
            padding-left: 1vw;
            position: absolute;
            right: 1vw;
            bottom: 4px;;
            z-index: 1000;
            margin: 0;
            @media screen and (max-width: 600px){
                font-size: 0.6rem;
            }
        }
    }
    
    #tag-line{
        color: #053050;
        position: absolute;
        top: 40vh;
        left: 8vw;
        z-index: 500;
        h1{
            span{
                opacity: 0;
                animation: reveal 9s infinite;
            }
                span:nth-child(1) { animation-delay: 1.2s; }
                span:nth-child(2) { animation-delay: 2s; }
                span:nth-child(3) { animation-delay: 2.5s; }
                span:nth-child(4) { animation-delay: 3s; }
                @keyframes reveal {
                    0% { opacity: 0; }
                    10% { opacity: 1; }
                    70% { opacity: 1; }  /* full sentence stays visible */
                    100% { opacity: 0; }
                }
        }

        h2{
            span{
                opacity: 0;
                animation: reveal 9s infinite;
            }
                span:nth-child(1) { animation-delay: 3s; }
                span:nth-child(2) { animation-delay: 3.5s; }
                span:nth-child(3) { animation-delay: 4s; }
                span:nth-child(4) { animation-delay: 4.5s; }
                @keyframes reveal {
                    0% { opacity: 0; }
                    10% { opacity: 1; }
                    70% { opacity: 1; }  /* full sentence stays visible */
                    100% { opacity: 0; }
                }
        }
    }
    
    .loading{
        position: absolute;
        width: 100%;
        height: 10vh;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        opacity: 0.5;
        z-index: 100;
        @media screen and (max-width: 600px){
            height: 20vh;
        }
        @media screen and (max-width: 400px){
            height: 25vh;
        }
    }
`

const Home = () => {
    const defaultvalue = { per10gram: 0, per1tola: 0 };
    const [silverPrice, setSilverPrice] = useState(defaultvalue);
    const [loading, setLoading] = useState(false);
    const [goldPrice, setGoldPrice] = useState(defaultvalue);
    const url = 'https://nepali-gold-silver-rate-live.p.rapidapi.com/api/rates/Nepal';

    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (video) {
            video.muted = true;
            video.play().catch(() => { });
        }
    }, []);
    useEffect(() => {
        const fetchPrice = async () => {
            try {
                setLoading(true);
                const response = await fetch(url, {
                    method: "GET",
                    headers: {
                        "x-rapidapi-key": 'e4b3fc65admshb2f097fd92709e6p16f0bejsn1af72fa43f7c',
                        "x-rapidapi-host":
                            "nepali-gold-silver-rate-live.p.rapidapi.com",
                    },
                });

                const result = await response.json();
                setSilverPrice({ per10gram: result?.metals[1]?.types[0]?.per10gram || "000", per1tola: result?.metals[1]?.types[0]?.per1tola || "000" })
                setGoldPrice({ per10gram: result?.metals[0]?.types[0]?.per10gram || "000", per1tola: result?.metals[0]?.types[0]?.per1tola || "000" })
                setLoading(false);
            } catch (error) {
                setLoading(false);
                console.error("Error fetching price:", error);
            }
        };

        fetchPrice();
    }, []);

    return (
        <HomeWrapper>
            <div id="background-image">
                <div class="bg-wrapper">
                    <div id="bg-color"><img src={LogoImg} alt="logo img" /></div>
                </div>
                <div id="tag-line">
                    <h1>
                        <span className="w1">Excellence </span>
                        <span className="w2">in </span>
                        <span className="w3">Silver</span>
                    </h1>
                    <h2>
                        <span>Trust </span>
                        <span>in </span>
                        <span>Every </span>
                        <span>Gram</span>
                    </h2>
                </div>
                <video ref={videoRef} muted playsInline loop controlsList="nofullscreen" preload="auto">
                    <source src={BgVideo} type="video/mp4" />
                    {/* Fallback text for browsers that don't support the video tag */}
                    Your browser does not support the video tag.
                </video>
            </div>
            <div id="silver-gold-price">
                <div id="price-wrapper">
                    <div className="price-info">
                        <img src={SilverBar} alt="silver" />
                        <div className="price">
                            <span>10 gram = Rs. {silverPrice?.per10gram || "000"}</span><br />
                            <span>1 tola = Rs. {silverPrice?.per1tola || "000"}</span>
                        </div>
                    </div>
                    <div className="price-info">
                        <img src={GoldBar} alt="Gold" />
                        <div className="price">
                            <span>10 gram = Rs. {goldPrice?.per10gram || "000"}</span><br />
                            <span>1 tola = Rs. {goldPrice?.per1tola || "000"}</span>
                        </div>
                    </div>
                </div>
                <p>Note: Prices are updated on working days at 10:30 AM</p>
                {loading && <div className="loading"><img src={Loading} alt="loading" /></div>}
            </div>
        </HomeWrapper>
    )
}

export default Home;